module.exports = __webpack_public_path__ + "img/9788937834950.5b84eef9.jpg";